import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useGlobalContext } from '../../contexts/GlobalContext';

//Modelos
import SearchDeclaracionesModel from '../../models/SearchDeclaraciones';

//Componentes
import Spinner from '../../components/spinner/Spinner';
import SearchDeclaraciones from './SearchDeclaraciones';

function SearchDeclaracionesContainer() {
    const {
        token,
        masters,
        localeDateFormat,
        tablePage,
        setTablePage,
        SearchParameters,
        dispatchSearchParameters,
    } = useGlobalContext();
    const FormMethods = useForm();

    const [loader, setLoader] = useState(false);

    /**Funcion que se ejecuta cuando se submitea el form para buscar Declaraciones */
    async function onSearch(data) {
        const DeclaracionforSearch = new SearchDeclaracionesModel(data);

        // console.log(DeclaracionforSearch);

        dispatchSearchParameters({
            type: 'DECLARACIONES',
            payload: {
                token,
                ...DeclaracionforSearch,
                pagina: tablePage,
                cantidad: 10,
            },
        });

        setTablePage(1);
    }

    return loader ? (
        <Spinner />
    ) : (
        <SearchDeclaraciones
            states={{ masters, localeDateFormat, SearchParameters }}
            functions={{ ...FormMethods, onSearch }}
        />
    );
}

export default SearchDeclaracionesContainer;
